<template>
   <div class="row justify-content-center supportForm">
      <div v-if="!postMsg" class="col-md-12">
         <div class="form-wrapper">
            <form method="post" action="" @submit="onSubmit">
               <div class="card-group">
                  <div class="card card-1">
                     <div class="card-header pb-0">
                        <div class="card-heading-wrapper d-flex justify-content-center">
                           <h1 class="mb-1">
                              Get Support
                           </h1>
                        </div>
                     </div>
                     <div class="card-body">
                        <Name ref="nameComponent" :value="form.name" />
                        <div class="row">
                           <div class="col-md-6 pr-md-1">
                              <Email ref="emailComponent" :value="form.email" />
                           </div>
                           <div class="col-md-6 pr-md-1">
                              <Company ref="companyComponent" :value="form.company" />
                           </div>
                        </div>
                        <hr />
                        <div class="row">
                           <div class="col-md-7 pr-md-1">
                              <div class="form-group">
                                 <span class=" theme-selector-label"
                                    >Do you have an active FusionCharts subscription?</span
                                 >
                              </div>
                           </div>
                           <div class="col-md-5 pr-md-1">
                              <div class="form-group">
                                 <div role="group" class="">
                                    <div
                                       id=""
                                       role="radiogroup"
                                       tabindex="-1"
                                       class="theme-selector-item"
                                    >
                                       <div
                                          class="custom-control custom-radio custom-control-inline"
                                       >
                                          <input
                                             v-model="check"
                                             type="radio"
                                             autocomplete="off"
                                             class="custom-control-input"
                                             value="yes"
                                          />
                                          <label for="" class="custom-control-label">
                                             <span>Yes</span>
                                          </label>
                                       </div>
                                       <div
                                          class="custom-control custom-radio custom-control-inline"
                                       >
                                          <input
                                             v-model="check"
                                             type="radio"
                                             autocomplete="off"
                                             class="custom-control-input"
                                             value="no"
                                             checked
                                          />
                                          <label for="" class="custom-control-label">
                                             <span>No</span>
                                          </label>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <TextBox
                           v-if="check === 'yes'"
                           ref="textBoxComponent"
                           invalid-feed-back="Tell us your FusionCharts Subscription Order Id!"
                           valid-feed-back="Sounds good."
                           data-name="subscriptionId"
                           label="FusionCharts Subscription Order ID"
                        />

                        <div class="row">
                           <div class="col-md-7">
                              <Select
                                 ref="selectForProductComponent"
                                 :options="[
                                    'FusionCharts Suite XT',
                                    'FusionCharts XT',
                                    'FusionWidgets XT',
                                    'PowerCharts XT',
                                    'FusionMaps XT',
                                    'Custom Maps',
                                    'FusionTime',
                                    'FusionExport',
                                    'FusionGrid',
                                 ]"
                                 place-holder="Which product do you need help with?"
                                 invalid-feedback="Please select the product."
                                 valid-feedback="Sounds good."
                                 data-name="product"
                                 @change="onChange"
                              />
                           </div>
                           <div class="col-md-5">
                              <Select
                                 ref="selectForProductVersionComponent"
                                 :options="versions"
                                 place-holder="Product version"
                                 invalid-feedback="Please select the product version."
                                 valid-feedback="Sounds good."
                                 data-name="version"
                              />
                           </div>
                        </div>

                        <TextBox
                           ref="textBoxSubjectComponent"
                           invalid-feed-back="What's the nature of the issue you're facing?"
                           valid-feed-back="Sounds good."
                           data-name="subject"
                           label="Subject"
                        />

                        <Message
                           ref="messageComponent"
                           message="Tell us more about your issue"
                           valid-feedback="Looks good."
                           invalid-feedback="Tell us a bit more, so that we can help you better."
                           :value="form.message"
                        />

                        <div class="d-none">
                           <!-- detecting country -->
                           <input v-getAutoCountryName type="hidden" />
                        </div>
                        <button
                           type="submit"
                           :disabled="btnLoading"
                           class="btn btn-primary-grad btn-block mb-1"
                        >
                           <i v-if="btnLoading" class="loadingSpinner" />
                           <span>CONTACT TECH SUPPORT</span>
                        </button>
                        <div class="d-flex align-items-center justify-content-center">
                           <!-- <i class="fc_select" /> -->
                           <span class="ml-1 small text-muted">
                              By signing up you agree to FusionCharts
                              <b-link
                                 href="https://www.ideracorp.com/legal/privacypolicy"
                                 target="_blank"
                                 rel="noopener noreferrer"
                              >
                                 privacy policy
                              </b-link>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </form>
         </div>
      </div>
      <div v-if="postMsg" class="col-12 text-center">
         <h1 class="mb-1">Thanks for contacting us.</h1>
         <p class="subheading">
            One of our support representatives will get in touch with you soon.
         </p>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import $service from '../../util/service.js';
import Name from './elements/Name';
import Email from './elements/Email';
import Company from './elements/Company';
import Message from './elements/Message';
import Select from './elements/Select';
import TextBox from './elements/TextBox';

export default {
   components: {
      Name,
      Email,
      Company,
      Message,
      Select,
      TextBox,
   },

   data() {
      return {
         btnLoading: false,
         postMsg: false,
         subscriptionStatus: false,
         attemptSubmit: false,
         ...(process.browser && { trackerContactus: this.$tracker.contactus }),
         purpose_options: [
            { value: '', text: '' },
            { value: 'sales', text: 'Product and sales queries' },
            { value: 'others', text: 'Anything else' },
         ],
         action: 'contacts',
         check: 'no',
         form: {
            name: '',
            email: '',
            company: '',
            subscriptionId: '',
            product: '',
            version: '',
            subject: '',
            message: '',
            country: '',
            purpose: 'support',
            form: 'support',
         },
         versions: [],
         fcVersionNumbers: [
            '4.2.0',
            '4.1.0',
            '4.0.0',
            '3.23.0',
            '3.22.0',
            '3.21.0',
            '3.20.0',
            '3.19.0',
            '3.18.0',
            '3.17.0',
            '3.16.0',
            '3.15.3',
            '3.15.2',
            '3.15.1-sr.1',
            '3.15.1',
            '3.15.0-sr.1',
            '3.15.0',
            '3.14.1',
            '3.14.0-sr.1',
            '3.14.0',
            '3.13.5-sr.1',
            '3.13.5',
            '3.13.4',
            '3.13.3-sr.1',
            '3.13.3',
            '3.13.2-sr.1',
            '3.13.2',
            '3.13.1-sr.1',
            '3.13.1',
            '3.13.0',
            '3.12.1',
            '3.12.0',
            '3.11.3',
            '3.11.2 ',
            '3.11.0',
            '3.10.1',
            '3.10.0',
            'others',
         ],
         ftVersionNumbers: [
            '2.9.0',
            '2.8.0',
            '2.7.0',
            '2.6.0',
            '2.5.0',
            '2.4.0',
            '2.3.0',
            '2.2.0',
            '2.1.1',
            '2.1.0',
            '2.0.0',
            '1.3.0',
            '1.2.0',
            '1.1.0',
            '1.0.0',
            'others',
         ],
         fgVersionNumbers: ['1.1.1'],
         feVersionNumbers: [
            '2.0.0',
            '1.2.2',
            '1.2.1',
            '1.2.0',
            '1.1.1',
            '1.1.0',
            '1.0.3',
            '1.0.2',
            '1.0.0',
            'others',
         ],
      };
   },

   computed: {
      ...mapState(['csrfToken']),
      productOption() {
         const arr = [];
         this.purpose_options.forEach(i => {
            arr.push(i.text);
         });
         return arr;
      },
   },

   watch: {
      versions() {
         this.form.version = '';
         this.$refs.selectForProductVersionComponent.form.data = '';
         this.$refs.selectForProductVersionComponent.validateFieldData();
      },
   },

   // mounted() {
   //    this.trackerContactus.support();
   // },

   methods: {
      onChange(product) {
         if (product.toLowerCase() === 'fusiontime') {
            this.versions = this.ftVersionNumbers;
         } else if (product.toLowerCase() === 'fusionexport') {
            this.versions = this.feVersionNumbers;
         } else if (product.toLowerCase() === 'fusiongrid') {
            this.versions = this.fgVersionNumbers;
         } else {
            this.versions = this.fcVersionNumbers;
         }
      },

      updateFormData() {
         this.form.name = this.$refs.nameComponent.form.name;
         this.form.email = this.$refs.emailComponent.form.email;
         this.form.company = this.$refs.companyComponent.form.company;
         this.form.message = this.$refs.messageComponent.form.message;
         this.form.subject = this.$refs.textBoxSubjectComponent.form.data;
         this.check === 'yes' && (this.form.subscriptionId = this.$refs.textBoxComponent.form.data);
         this.form.product = this.$refs.selectForProductComponent.form.data;
         this.form.version = this.$refs.selectForProductVersionComponent.form.data;
      },
      validateFormData() {
         this.$refs.emailComponent.validateMailData();
         this.$refs.nameComponent.validateNameData();
         this.$refs.companyComponent.validateCompanyData();
         this.$refs.messageComponent.validateMessageData();
         this.$refs.textBoxSubjectComponent.validateFieldData();
         this.check === 'yes' && this.$refs.textBoxComponent.validateFieldData();
         this.$refs.selectForProductComponent.validateFieldData();
         this.$refs.selectForProductVersionComponent.validateFieldData();
      },
      onSubmit(evt) {
         evt.preventDefault();
         this.attemptSubmit = true;
         // validation and form update
         this.updateFormData();
         this.validateFormData();

         this.form._csrf = this.csrfToken;
         this.form.source = this.$route.path;

         if (
            this.missingName &&
            !this.isValidEmail &&
            !this.isNotEmpty(this.form.company) &&
            !this.isNotEmpty(this.form.product) &&
            !this.isNotEmpty(this.form.version) &&
            !this.isNotEmpty(this.form.subject) &&
            !this.isNotEmpty(this.form.message)
         ) {
            if (this.check === 'yes' && this.form.subscriptionId === '') {
               return false;
            }

            this.btnLoading = true;

            const trackOb = {
               Name: this.form.name,
               Email: this.form.email,
               Company: this.form.company,
               OrderID: this.form.subscriptionId,
               Product: this.form.product,
               Version: this.form.version,
               Subject: this.form.subject,
               Message: this.form.message,
            };

            this.trackerContactus.techSupport(trackOb);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
               event: 'supportformSubmissionSuccess',
            });

            $service
               .postDB(this.action, this.form)
               .then(response => {
                  if (response.status === 200) {
                     this.postMsg = true;
                  }
               })
               .catch(err => console.error('fail', err));
         }
         return false;
      },
   },
};
</script>
<style lang="scss" scoped>
.theme-selector {
   padding: 0 10px;

   &-label {
      font-weight: bold;
   }

   &-list {
      display: inline-block;
      margin: 0;
      padding: 0 10px;
   }
}
.theme-selector-item {
   input {
      cursor: pointer;
      z-index: 1;
      width: 100%;
      height: 100%;
      left: 0;
   }

   label {
      padding: 5px 10px 5px 30px;
      border-radius: 4px;

      &::before,
      &::after {
         top: 10px;
         left: 7px;
         width: 1.5rem;
         height: 1.5rem;
      }

      &::before {
         background: #fff;
         border: 2px solid #949697;
         box-shadow: none;
      }
   }

   input:checked ~ label {
      color: #48b884;
      font-weight: 600;
      box-shadow: 0 4px 9px 0 rgba(104, 105, 128, 0.22);

      &::before {
         background-color: #fff !important;
         background-image: none !important;
         border: 2px solid #48b884;
      }

      &::after {
         background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='https://www.w3.org/2000/svg' viewBox='-5 -5 10 10'%3E%3Ccircle r='5' fill='%2348B884'/%3E%3C/svg%3E") !important;
         background-size: 60%;
      }
   }

   input:focus ~ label {
      &::before {
         box-shadow: none !important;
      }
   }
}
</style>
